import { render, staticRenderFns } from "./ControlledHerbsDialog.vue?vue&type=template&id=260f3b3a&scoped=true&"
import script from "./ControlledHerbsDialog.vue?vue&type=script&lang=js&"
export * from "./ControlledHerbsDialog.vue?vue&type=script&lang=js&"
import style0 from "./ControlledHerbsDialog.vue?vue&type=style&index=0&id=260f3b3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260f3b3a",
  null
  
)

export default component.exports